module.exports = __webpack_public_path__ + "img/dinosaurio-meme.c39e2d9e.jpeg";